import React, { useState } from "react"
import { useForm } from "react-hook-form"
import Input from "../../atoms/input/input"
import Button from "../../atoms/button/button"
import emailReguex from "../../../utils/emailRegex"
import "./parent-form.scss"

const ParentForm = ({ onSubmit, defaultValues }) => {
  const { register, errors, watch, handleSubmit } = useForm({
    defaultValues: { ...defaultValues, parentMethod: "SMS" },
  })

  const [labelParentContact, setLabelParentContact] = useState("CELULAR")

  return (
    <div className="f-parent-change-birthdate">
      <h2 className="f-title-modal">
        Necesitamos la información de tus padres o acudiente
      </h2>
      <p className="f-description-modal">
        Como aún eres menor de edad debemos solicitarle a tus padres o a tu
        acudiente que autorice tu cambio de fecha de nacimiento, déjanos sus
        datos para ponernos en contacto con ellos
      </p>
      <form className="f-form-parent" onSubmit={handleSubmit(onSubmit)}>
        <Input
          name="parentName"
          label="NOMBRE DE TU ACUDIENTE"
          register={register({
            required: { value: true, message: "*Este campo es requerido" },
          })}
          error={errors.parentName}
        />
        <p className="f-form-contact__title">LO CONTACTAMOS POR:</p>
        <div className="f-form-contact">
          <div className="f-form-contact-radio">
            <Input
              type="radio"
              name="parentMethod"
              register={register({ required: true })}
              value="SMS"
              onChange={() => {
                setLabelParentContact("CELULAR")
              }}
            />
            <label className="f-form-contact-radio__label">
              Celular (SMS){" "}
            </label>
          </div>
          <div className="f-form-contact-radio">
            <Input
              type="radio"
              name="parentMethod"
              register={register({ required: true })}
              value="EMAIL"
              onChange={() => {
                setLabelParentContact("CORREO")
              }}
            />
            <label className="f-form-contact-radio__label">Correo</label>
          </div>
        </div>
        <div className="f-form-footer">
          <Input
            name="parentMethodValue"
            label={`${labelParentContact} DE TU ACUDIENTE`}
            register={register({
              required: { value: true, message: "*Este campo es requerido" },
              validate: {
                validateField: value => {
                  if (labelParentContact === "CORREO") {
                    if (emailReguex().test(value)) {
                      return true
                    } else {
                      return "*Correo inválido"
                    }
                  } else if (labelParentContact === "CELULAR") {
                    if (
                      value.length >= parseInt(process.env.MIN_DIGITS) &&
                      value.length <= parseInt(process.env.MAX_DIGITS)
                    ) {
                      return true
                    } else {
                      return "*Celular inválido"
                    }
                  }
                },
              },
            })}
            error={errors.parentMethodValue}
          />
          <Input
            label={`CONFIRMA EL  ${labelParentContact} DE TU ACUDIENTE`}
            name="parentMethodValueConfirm"
            register={register({
              required: { value: true, message: "*Este campo es requerido" },
              validate: {
                validateField: value => {
                  if (labelParentContact === "CORREO") {
                    if (value === watch("parentMethodValue")) {
                      return true
                    } else {
                      return "Los correos no coinciden."
                    }
                  } else if (labelParentContact === "CELULAR") {
                    if (value === watch("parentMethodValue")) {
                      return true
                    } else {
                      return "El celular no coincide."
                    }
                  }
                },
              },
            })}
            error={errors.parentMethodValueConfirm}
          />
        </div>
        <div className="f-buttons-container">
          <Button title="Finalizar" className="primary-pink" type="submit" />
        </div>
      </form>
    </div>
  )
}

export default ParentForm
